import storage from 'redux-persist/lib/storage';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';

import userReducer from './reducers/UserSlice';
import themeReducer from './reducers/ThemeSlice';
import languageReducer from './reducers/LanguageSlice';
import recalculationReducer from './reducers/RecalculationSlice';
import internalNotificationsReducer from './reducers/InternalNotificationsSlice';

const rootReducer = combineReducers({
  user: userReducer,
  theme: themeReducer,
  language: languageReducer,
  recalculation: recalculationReducer,
  internalNotifications: internalNotificationsReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['recalculation'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const setupStore = () => {
  return configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
  });
};

export const store = setupStore();
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof persistedReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
